import { Box, FormField, Checkbox, Text, InfoIcon } from '@wix/design-system';
import React__default, { useContext, useState } from 'react';
import { RicosContext } from 'ricos-context';
import { LINK_SETTINGS_CHECKBOX_NEW_TAB, LINK_SETTINGS_CHECKBOX_NOREFERRER, LINK_SETTINGS_CHECKBOX_NOFOLLOW, LINK_SETTINGS_CHECKBOX_SPONSORED } from './data-hooks.js';
import { LinkInput } from '../link-input/link-input.js';
import '../link-input/utils.js';
import 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ZINDEX = 101e3;
const LinkSettings = ({ linkValue, onChange, options }) => {
  var _a;
  const { t } = useContext(RicosContext);
  const [state, setState] = useState({
    url: linkValue.url || "",
    openInNewTab: !!linkValue.openInNewTab,
    noreferrer: !!linkValue.noreferrer,
    nofollow: !!linkValue.nofollow,
    sponsored: !!linkValue.sponsored
  });
  const handleCheckboxChange = (key) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { [key]: !prevState[key] }));
    onChange(__spreadProps(__spreadValues({}, state), { [key]: !state[key] }));
  };
  return /* @__PURE__ */ React__default.createElement(Box, { direction: "vertical", gap: "SP3", width: "100%" }, (options == null ? void 0 : options.showInputField) !== false ? /* @__PURE__ */ React__default.createElement(FormField, { label: t("GalleryImageSettings_Link_Label") }, /* @__PURE__ */ React__default.createElement(
    LinkInput,
    {
      value: (_a = state.url) != null ? _a : "",
      onChange: (url) => onChange(__spreadProps(__spreadValues({}, state), { url })),
      placeholder: t("LinkPanel_InputPlaceholder")
    }
  )) : null, /* @__PURE__ */ React__default.createElement(Box, { direction: "vertical", gap: "SP2" }, (options == null ? void 0 : options.showNewTabCheckbox) && /* @__PURE__ */ React__default.createElement(
    CheckboxWithInfoIcon,
    {
      dataHook: LINK_SETTINGS_CHECKBOX_NEW_TAB,
      checked: state.openInNewTab,
      onChange: () => handleCheckboxChange("openInNewTab"),
      textContent: "LinkPanel_Target_Checkbox",
      tooltipContent: null
    }
  ), (options == null ? void 0 : options.showNoReferrerCheckbox) && /* @__PURE__ */ React__default.createElement(
    CheckboxWithInfoIcon,
    {
      dataHook: LINK_SETTINGS_CHECKBOX_NOREFERRER,
      checked: state.noreferrer,
      onChange: () => handleCheckboxChange("noreferrer"),
      textContent: "LinkPanel_Noreferrer_Checkbox_Label",
      tooltipContent: "LinkPanel_Noreferrer_Tooltip"
    }
  ), (options == null ? void 0 : options.showNoFollowCheckbox) && /* @__PURE__ */ React__default.createElement(
    CheckboxWithInfoIcon,
    {
      dataHook: LINK_SETTINGS_CHECKBOX_NOFOLLOW,
      checked: state.nofollow,
      onChange: () => handleCheckboxChange("nofollow"),
      textContent: "LinkPanel_Nofollow_Checkbox",
      tooltipContent: "LinkPanel_Nofollow_Tooltip"
    }
  ), (options == null ? void 0 : options.showSponsoredCheckbox) && /* @__PURE__ */ React__default.createElement(
    CheckboxWithInfoIcon,
    {
      dataHook: LINK_SETTINGS_CHECKBOX_SPONSORED,
      checked: state.sponsored,
      onChange: () => handleCheckboxChange("sponsored"),
      textContent: "LinkPanel_Sponsored_Checkbox",
      tooltipContent: null
    }
  )));
};
const CheckboxWithInfoIcon = ({ checked, onChange, textContent, tooltipContent, dataHook }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React__default.createElement(Checkbox, { dataHook, size: "small", checked, onChange }, tooltipContent ? /* @__PURE__ */ React__default.createElement(Box, { verticalAlign: "middle", gap: "SP1" }, /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, t(textContent)), /* @__PURE__ */ React__default.createElement(
    InfoIcon,
    {
      size: "small",
      content: t(tooltipContent),
      tooltipProps: {
        appendTo: (el) => {
          var _a;
          return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
        },
        zIndex: ZINDEX
      }
    }
  )) : /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, t(textContent)));
};

export { LinkSettings };
//# sourceMappingURL=link-settings.js.map
